import svg from '../../../constants/svg';
import HeaderNav from '../../Molecules/HeaderNav';

interface Props {
  absolute?: boolean;
  theme?: 'light' | 'dark';
}

function Header({
  absolute = false,
  theme = 'dark'
}: Props) {
  return (
    <header
      className={`w-full py-4 md:py-6 ${
        absolute ? 'absolute top-0 left-0 z-30' : ''
      }`}
    >
      <div className="px-5 md:px-7">
        <div className="flex items-center justify-between">
          <a
            href="/"
            className="inline-flex w-28 shrink-0 md:w-32 lg:w-36"
          >
            {theme === 'dark' && svg.logoBlueSm}
            {theme === 'light' && svg.logoWhiteSm}
          </a>
          <HeaderNav
            menu={[
              {
                label: 'Home',
                id: '888',
                url: '#!'
              },
              {
                label: 'Vacatures',
                id: '999',
                url: '#!',
                subMenu: [
                  {
                    label: '(Field) Service Engineers',
                    url: '#!',
                    badge: '567 vacatures'
                  },
                  {
                    label: '(Field) Service Engineers',
                    url: '#!',
                    badge: '567 vacatures'
                  },
                  {
                    label: '(Field) Service Engineers',
                    url: '#!',
                    badge: '567 vacatures'
                  },
                  {
                    label: '(Field) Service Engineers',
                    url: '#!',
                    badge: '567 vacatures'
                  },
                  {
                    label: '(Field) Service Engineers',
                    url: '#!',
                    badge: '567 vacatures'
                  },
                  {
                    label: '(Field) Service Engineers',
                    url: '#!',
                    badge: '567 vacatures'
                  },
                  {
                    label: '(Field) Service Engineers',
                    url: '#!',
                    badge: '567 vacatures'
                  },
                  {
                    label: '(Field) Service Engineers',
                    url: '#!',
                    badge: '567 vacatures'
                  },
                  {
                    label: '(Field) Service Engineers',
                    url: '#!',
                    badge: '567 vacatures'
                  },
                  {
                    label: '(Field) Service Engineers',
                    url: '#!',
                    badge: '567 vacatures'
                  },
                  {
                    label: '(Field) Service Engineers',
                    url: '#!',
                    badge: '567 vacatures'
                  },
                  {
                    label: '(Field) Service Engineers',
                    url: '#!',
                    badge: '567 vacatures'
                  },
                  {
                    label: '(Field) Service Engineers',
                    url: '#!',
                    badge: '567 vacatures'
                  }
                ]
              },
              {
                label: 'Expertises',
                id: '666',
                url: '#!',
                subMenu: [
                  {
                    label: '(Field) Service Engineers',
                    url: '#!'
                  },
                  {
                    label: 'Mechanical Engineers',
                    url: '#!'
                  }
                ]
              },
              {
                label: 'Blog',
                id: '777',
                url: '#!'
              }
            ]}
            nav={[
              {
                label: 'Vacatures',
                url: '#!',
                subNav: [
                  {
                    label: '(Field) Service Engineers',
                    url: '#!',
                    icon: 'windmill'
                  },
                  {
                    label: 'Mechanical Engineers',
                    url: '#!',
                    icon: 'plug'
                  },
                  {
                    label:
                      'Software & Electrical Engineers',
                    url: '#!',
                    icon: 'code'
                  },
                  {
                    label: 'Monteurs Technische Dienst',
                    url: '#!',
                    icon: 'conveyor'
                  },
                  {
                    label: 'Machinebouwers',
                    url: '#!',
                    icon: 'gear'
                  },
                  {
                    label: 'Installatietechniek',
                    url: '#!',
                    icon: 'helmet'
                  },
                  {
                    label: 'Technisch-Commercieel',
                    url: '#!',
                    icon: 'chart'
                  },
                  {
                    label: 'Operators',
                    url: '#!',
                    icon: 'clipboard'
                  }
                ]
              },
              {
                label: 'Expertises',
                url: '#!',
                subNav: [
                  {
                    label: '(Field) Service Engineers',
                    url: '#!',
                    icon: 'plug'
                  },
                  {
                    label: 'Mechanical Engineers',
                    url: '#!',
                    icon: 'windmill'
                  },
                  {
                    label:
                      'Software & Electrical Engineers',
                    url: '#!',
                    icon: 'code'
                  },
                  {
                    label: 'Monteurs Technische Dienst',
                    url: '#!',
                    icon: 'conveyor'
                  },
                  {
                    label: 'Machinebouwers',
                    url: '#!',
                    icon: 'gear'
                  }
                ]
              },
              {
                label: 'Blog',
                url: '#!'
              },
              {
                label: 'Over Synsel',
                url: '#!'
              },
              {
                label: 'Contact',
                url: '#!'
              }
            ]}
            menuSecondary={[
              {
                label: 'Over Synsel',
                url: '#!'
              },
              {
                label: 'Werken bij',
                url: '#!'
              },
              {
                label: 'Contact',
                url: '#!'
              }
            ]}
            social={[
              {
                icon: 'facebook',
                url: '#!1'
              },
              {
                icon: 'linkedin',
                url: '#!'
              },
              {
                icon: 'instagram',
                url: '#!'
              }
            ]}
            theme={theme}
          />
        </div>
      </div>
    </header>
  );
}

export default Header;
